







































































import { Vue, Component, Prop } from "vue-property-decorator"
import { fetchAll, loginUrl, sendToEmail } from "@/api/policy"
import { IFilterValues, IPaginatedCollection, IPaginationRequest } from "@/api/types"
import { IPolicyWithBalanceInfo, IPolicy } from "@/types/policy"
import ListItemsView from "@/components/ListItemsView.vue"
import { StatusLabels } from './helper'
import { debounce } from "typescript-debounce-decorator"

@Component({
  components: { ListItemsView }
})
export default class List extends Vue {
    protected statusLabels = StatusLabels

    protected headers = [
        { text: "Id", value: "policy.id", align: "d-none" },
        { text: "Номер полиса", value: "policy.number" },
        { text: "Активирован", value: "policy.copayActivated" },
        { text: "Дата активиции", value: "policy.copayActivatedAt" },
        { text: "Статус", value: "policy.status" },
        { text: "Телефон", value: "policy.phoneNumber" },
        { text: "Банковская карта", value: "policy.paymentMethod.number" },
        { text: "Баланс, руб.", value: "balance" },
        { text: "Сумма списаний, руб.", value: "totalExpenses" },
        { text: "Сумма пополнений, руб.", value: "totalIncome" },
        { text: "", value: "action", width: 50 }
    ]

    protected inProcess = false
    protected filters: IFilterValues = {
      search: ''
    }

    protected result: IPaginatedCollection<IPolicyWithBalanceInfo> = {
        page: 1,
        limit: 20,
        totalItems: 0,
        data: []
    }

    created() {
      this.fetch(1)
    }

    @debounce(1000, { leading: false })
    searchChanged () {
      this.fetch(1)
    }

    limitChanged (limit: number) {
      this.result.limit = limit
      this.fetch(1)
    }

    async fetch (page: number = 1) {
      if (this.inProcess) return
      this.inProcess = true
      this.result.page = page
      try {
        this.result = await fetchAll({
          page: this.result.page,
          limit: this.result.limit,
        } as IPaginationRequest, this.filters)
        this.inProcess = false
      } catch (e) {
        this.inProcess = false
      }
    }

    async login (policy: IPolicy) {
      let result = await loginUrl(policy.id)
      window.open(result.url, '_blank')
    }

    async sendToEmail () {
      let { message } = await sendToEmail()
      this.$alerts.add('success', message, 5000)
    }
}
